//#region src/config/globalConstants.ts
var e = 800, t = 200, n = 1.25, r = 1;
//#endregion
export { r as DEFAULT_SCALE_FACTOR, t as MODAL_ANIMATION_DURATION, n as SCALE_FACTOR, e as TOOLTIP_DELAY };
